import { MAX_FREQ, MIN_FREQ } from "@/constants/conversionShowcase";

const hzToMel = (hz: number) => 2595 * Math.log10(1 + hz / 700);
const melToHz = (mel: number) => 700 * (Math.pow(10, mel / 2595) - 1);

// Divides the audible frequency range into perceptually equal bands using the mel scale, so each bar in the waveform visualiser represents a similar amount of perceived pitch distance.

export const generateFrequencyBands = (barCount: number) => {
  const minMel = hzToMel(MIN_FREQ);
  const maxMel = hzToMel(MAX_FREQ);
  const melStep = (maxMel - minMel) / barCount;
  return Array.from({ length: barCount }, (_, i) => ({
    low: melToHz(minMel + i * melStep),
    high: melToHz(minMel + (i + 1) * melStep),
  }));
};
